import { useState } from 'react';
import { IMAGE } from '../../constants';

/**
 * @function useImgUploader
 * @param {function} dispatch
 * @returns {object}
 */
function useImgUploader(dispatch) {
	const [isOpenDialog, setIsOpenDialog] = useState(false);
	const [previewImg, setPreviewImg] = useState({});
	const [payload, setPayload] = useState({ file: '', name: '', preview: '' });

	const onOpen = () => {
		setIsOpenDialog(true);
	};

	const onClose = () => {
		setIsOpenDialog(false);
	};

	const onReset = () => {
		setPreviewImg({});
	};

	const onChoose = (e) => {
		dispatch({ type: IMAGE, payload: payload });
		setIsOpenDialog(false);
	};

	const onDelete = () => {
		dispatch({ type: IMAGE, payload: { file: '', name: '', preview: '' } });
		setPreviewImg({});
	};

	const onChange = (e) => {
		const reader = new FileReader();
		reader.readAsDataURL(e.target.files[0]);
		return new Promise((resolve) => {
			reader.onload = () => {
				const tempPayload = {
					file: e.target.files[0],
					name: e.target.files[0].name,
					preview: reader.result,
				};
				setPreviewImg({ file: reader.result, name: e.target.files[0].name });
				setPayload(tempPayload);
				resolve();
			};
		});
	};

	return {
		isOpenDialog,
		previewImg,
		onOpen,
		onClose,
		onReset,
		onChoose,
		onDelete,
		onChange,
	};
}

export default useImgUploader;
